import { applyVueInReact } from 'vuereact-combined';

import UpgradeRequiredIndicator from '@/components/Billing/UpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import AppIcon from '@/react_app/common/AppIcon';
// import MaybeUpgradeRequiredIndicator, { RenderProps } from '@/react_app/common/MaybeUpgradeRequiredIndicator';
const ReactUpgradeRequiredIndicator = applyVueInReact(UpgradeRequiredIndicator);
const RoleSelectorItem = ({
	label,
	disabled,
	description,
	recommended,
	billingFeatureId,
	isUpgradeRequired,
}: {
	label: string;
	disabled?: boolean;
	description: string;
	recommended?: boolean;
	isUpgradeRequired: boolean;
	billingFeatureId: FeatureTypes | undefined;
}) => (
	<div className={`w-full h-full ${disabled ? 'opacity-50 cursor-not-allowed' : 'opacity-100'}`}>
		<div className="flex flex-align-center items-center">
			<div className="text-colorText text-sm ">{label}</div>
			{isUpgradeRequired && (
				<div className="ml-2">
					<ReactUpgradeRequiredIndicator billingFeatureId={billingFeatureId} />
				</div>
			)}
			{recommended && (
				<div className="ml-2 flex px-[5px] items-center border border-[#646E87] rounded max-w-[99px]">
					<div className="text-[#646E87] text-[10px] mr-1">Recommended</div>
					<AppIcon name="recommended-star" />
				</div>
			)}
		</div>
		<div className="text-[11px] text-colorTextSecondary">{description}</div>
	</div>
);
export default RoleSelectorItem;

// const itemRender = (renderProps?: RenderProps) => {
// 	const { indicator, openUpgrade } = renderProps || {};
// 	return (
// 		<div onClick={openUpgrade} className={`w-full h-full ${disabled ? 'opacity-50 cursor-not-allowed' : 'opacity-100'}`}>
// 			<div className="flex flex-align-center items-center">
// 				<div className="text-colorText text-sm">{label}</div>
// 				{indicator}
// 				{recommended && (
// 					<div className="ml-2 flex px-[5px] items-center border border-[#646E87] rounded max-w-[103px]">
// 						<div className="text-[#646E87] text-[10px] mr-2">Recommended</div>
// 						<AppIcon name="recommended-star" />
// 					</div>
// 				)}
// 			</div>
// 			<div className="text-[11px] text-colorTextSecondary">{description}</div>
// 		</div>
// 	);
// };
// const indicatorProps = { class: 'ml-2' };
// return <MaybeUpgradeRequiredIndicator indicatorProps={indicatorProps} billingFeatureId={billingFeatureId} render={itemRender} />;
